"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAddress = void 0;
const bech32 = __importStar(require("bech32"));
const errors_1 = require("./errors");
/**
 * The human-readable-part of the bech32 addresses.
 */
const HRP = "erd";
/**
 * A user Address, as an immutable object.
 */
class UserAddress {
    constructor(buffer) {
        this.buffer = buffer;
    }
    static fromBech32(value) {
        let decoded;
        try {
            decoded = bech32.decode(value);
        }
        catch (err) {
            throw new errors_1.ErrBadAddress(value, err);
        }
        if (decoded.prefix != HRP) {
            throw new errors_1.ErrBadAddress(value);
        }
        let pubkey = Buffer.from(bech32.fromWords(decoded.words));
        return new UserAddress(pubkey);
    }
    /**
     * Returns the hex representation of the address (pubkey)
     */
    hex() {
        return this.buffer.toString("hex");
    }
    /**
     * Returns the bech32 representation of the address
     */
    bech32() {
        let words = bech32.toWords(this.pubkey());
        let address = bech32.encode(HRP, words);
        return address;
    }
    /**
     * Returns the pubkey as raw bytes (buffer)
     */
    pubkey() {
        return this.buffer;
    }
    /**
     * Returns the bech32 representation of the address
     */
    toString() {
        return this.bech32();
    }
    /**
     * Converts the address to a pretty, plain JavaScript object.
     */
    toJSON() {
        return {
            bech32: this.bech32(),
            pubkey: this.hex()
        };
    }
}
exports.UserAddress = UserAddress;
//# sourceMappingURL=userAddress.js.map